(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["raincoat-size-finder"] && !Shopify.designMode) return;
  try {
    class RaincoatSizeFinder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.lengthUnit = 'cm';
      this.weightUnit = 'kg';
      this.sizes = [
        { name: 'S', neck: 39.5, chest: 59, back: 42, weight: 16 },
        { name: 'M', neck: 44, chest: 69, back: 50, weight: 22 },
        { name: 'L', neck: 50, chest: 80, back: 58, weight: 35 }
      ];
      this.copy = this.querySelector('[data-size-copy]');
      this.querySelectorAll('[data-size-tab]').forEach((button) => button.addEventListener('click', () => this.selectTab(button.dataset.sizeTab)));
      this.querySelectorAll('[data-length-unit]').forEach((button) => button.addEventListener('click', () => this.setLengthUnit(button.dataset.lengthUnit)));
      this.querySelectorAll('[data-weight-unit]').forEach((button) => button.addEventListener('click', () => this.setWeightUnit(button.dataset.weightUnit)));
      this.querySelectorAll('[data-measurement]').forEach((input) => input.addEventListener('input', () => this.recommendByMeasurements()));
      this.querySelector('[data-weight]').addEventListener('input', () => this.recommendByWeight());
    }

    selectTab(tab) {
      this.querySelectorAll('[data-size-tab]').forEach((button) => {
        const active = button.dataset.sizeTab === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active.toString());
      });
      this.querySelectorAll('[data-size-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.sizePanel !== tab;
      });
      this.clearResult();
    }

    setLengthUnit(unit) {
      if (unit === this.lengthUnit) return;
      const factor = unit === 'in' ? 1 / 2.54 : 2.54;
      this.querySelectorAll('[data-measurement]').forEach((input) => {
        if (input.value) input.value = (Number(input.value) * factor).toFixed(1);
      });
      this.lengthUnit = unit;
      this.querySelectorAll('[data-length-unit]').forEach((button) => {
        const active = button.dataset.lengthUnit === unit;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active.toString());
      });
      this.querySelectorAll('[data-length-suffix]').forEach((suffix) => { suffix.textContent = unit; });
      this.recommendByMeasurements();
    }

    setWeightUnit(unit) {
      if (unit === this.weightUnit) return;
      const input = this.querySelector('[data-weight]');
      const factor = unit === 'lb' ? 2.2046226218 : 1 / 2.2046226218;
      if (input.value) input.value = (Number(input.value) * factor).toFixed(1);
      this.weightUnit = unit;
      this.querySelectorAll('[data-weight-unit]').forEach((button) => {
        const active = button.dataset.weightUnit === unit;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active.toString());
      });
      this.querySelector('[data-weight-suffix]').textContent = unit;
      this.recommendByWeight();
    }

    recommendByMeasurements() {
      const values = {};
      let complete = true;
      this.querySelectorAll('[data-measurement]').forEach((input) => {
        const value = Number(input.value);
        if (!value) complete = false;
        values[input.dataset.measurement] = this.lengthUnit === 'in' ? value * 2.54 : value;
      });
      if (!complete) return this.clearResult();
      const requirements = Object.entries(values).map(([key, value]) => this.sizes.findIndex((size) => value <= size[key]));
      if (requirements.includes(-1)) return this.showNoFit();
      const index = Math.max(...requirements);
      this.showRecommendation(this.sizes[index].name, new Set(requirements).size > 1);
    }

    recommendByWeight() {
      const input = this.querySelector('[data-weight]');
      if (!Number(input.value)) return this.clearResult();
      const weight = this.weightUnit === 'lb' ? Number(input.value) / 2.2046226218 : Number(input.value);
      const size = this.sizes.find((option) => weight <= option.weight);
      if (!size) return this.showNoFit();
      this.showRecommendation(size.name, false);
    }

    showRecommendation(size, spansSizes) {
      const result = this.querySelector('[data-size-result]');
      const recommendation = this.copy.content.querySelector('[data-recommendation]').textContent.replace('__SIZE__', size);
      const note = spansSizes ? this.copy.content.querySelector('[data-spans]').textContent : this.copy.content.querySelector('[data-check]').textContent;
      result.innerHTML = `<strong>${recommendation}</strong><span>${note}</span>`;
      result.hidden = false;
    }

    showNoFit() {
      const result = this.querySelector('[data-size-result]');
      result.textContent = this.copy.content.querySelector('[data-no-fit]').textContent;
      result.hidden = false;
    }

    clearResult() {
      const result = this.querySelector('[data-size-result]');
      result.hidden = true;
      result.textContent = '';
    }
  }

  if (!customElements.get('raincoat-size-finder')) customElements.define('raincoat-size-finder', RaincoatSizeFinder);
  } catch(e) { console.error(e); }
})();

})();
